import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk';
import rootReducer from 'reducers';
import rootEpic from 'epics';

import createThrottle from 'redux-throttle';
import createDebounce from 'redux-debounced';

const epicMiddleware = createEpicMiddleware();
const debouncer = createDebounce();
const throttle = createThrottle(300);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(epicMiddleware, thunk, throttle, debouncer)
));

export default function configureStore() {
  return store;
}

epicMiddleware.run(rootEpic);



// WEBPACK FOOTER //
// ./src/store/configureStore.js